/**
 * Acquires ACF data from the CMS.
 * @returns {Promise<object>} The data from the CMS.
 */
async function fetchFields() {
    try {
        const storageData = window.localStorage.getItem('disneyrewards_tracking_codes');
        const { fetched } = JSON.parse(storageData);

        if (fetched === 'true') {
            window.localStorage.setItem(
                'disneyrewards_tracking_codes',
                JSON.stringify({
                    fetched: 'false'
                })
            );

            const { postId, restNonce } = window.disneyRewards?.globals ?? {};

            if (!restNonce) {
                throw new Error('REST nonce is not available, could not fetch tracking codes data.');
            }
            const formData = new FormData();
            if (postId) {
                formData.append('id', postId);
            } else {
                window.localStorage.setItem(
                    'disneyrewards_tracking_codes',
                    JSON.stringify({
                        fetched: 'true'
                    })
                );

                throw new Error('Post ID was not available, could not fetch tracking codes data.');
            }

            const req = await fetch(`/wp-json/disneyrewards/tracking-codes`, {
                method: 'POST',
                headers: new Headers({
                    'X-WP-Nonce': restNonce
                }),
                body: formData
            });

            const result = await req.json();

            window.localStorage.setItem(
                'disneyrewards_tracking_codes',
                JSON.stringify({
                    fetched: 'true'
                })
            );

            if (req.status !== 200) {
                throw result;
            }

            return result;
        }

        return false;
    } catch (error) {
        return false;
    }
}

export { fetchFields };
